export default __webpack_public_path__ + "static/media/chat2.f93109cc.png";